<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start>
    <v-layout
      justify-center
      wrap>
      <v-flex>
        <formAdminOnboardingAcctDatatable :type="'view'"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'

export default {

}
</script>
<style lang="scss" scoped>

</style>
